"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : FORM : FIELD : TEXTAREA --------------- ++++++++++ */


var _default = {
  textarea: {
    backgroundColor: 'transparent',
    border: '0',
    color: 'inherit',
    fontFamily: 'inherit',
    fontSize: (0, _index.pxToEm)(16),
    width: '100%',
    height: 'inherit',
    //pxToEm(50),
    margin: '0',
    padding: '0',
    outline: 'none',
    whiteSpace: function whiteSpace(props) {
      return props.nowrap ? 'nowrap' : 'initial';
    },
    extend: (0, _index.coloredScrollBar)(function (props) {
      return props.scrollbarColor ? props.scrollbarColor : 'transparent';
    }),
    '&::placeholder': {
      color: _index.theme.color.supporting.dark.swatch,
      opacity: '.4'
    },
    resize: 'none',
    paddingTop: (0, _index.pxToEm)(10),
    paddingBottom: (0, _index.pxToEm)(10)
  }
};
exports.default = _default;